if (!customElements.get('image-cards')) {
  customElements.define(
    'image-cards',
    class ImageCards extends HTMLElement {
      constructor() {
        super();
        this.resizeRaf = null;
        this.handleViewportChange = this.handleViewportChange.bind(this);
      }

      connectedCallback() {
        this.selectors = {
          sliderWrapper: '.image-cards__inner',
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
          pagination: '.swiper-pagination',
        };
        this.classes = {
          grid: 'f-grid',
          swiper: 'swiper',
          swiperWrapper: 'swiper-wrapper',
        };

        this.sectionId = this.dataset.sectionId;
        this.sectionEl = this.closest(`.section-${this.sectionId}`);
        this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);

        this.enableSlider = this.dataset.enableSlider === 'true';
        this.items = parseInt(this.dataset.items);
        this.tabletItems = parseInt(this.dataset.tabletItems);
        this.laptopItems = parseInt(this.dataset.laptopItems);
        this.paginationType = this.dataset.paginationType || 'bullets';
        this.mobileBreakpoint = Number.parseInt(this.dataset.mobileBreakpoint || '768', 10);

        this.sliderInstance = false;

        if (!this.enableSlider) {
          this.updateOverlayMinHeight();
          return;
        }

        this.mqlMobile = window.matchMedia(`(max-width: ${this.mobileBreakpoint - 0.02}px)`);
        this.mqlMobile.onchange = this.handleViewportChange;
        window.addEventListener('resize', this.handleViewportChange);
        this.init();
      }

      disconnectedCallback() {
        if (this.mqlMobile) this.mqlMobile.onchange = null;
        window.removeEventListener('resize', this.handleViewportChange);
        if (this.resizeRaf) window.cancelAnimationFrame(this.resizeRaf);
      }

      handleViewportChange() {
        if (this.resizeRaf) window.cancelAnimationFrame(this.resizeRaf);
        this.resizeRaf = window.requestAnimationFrame(() => {
          this.init();
          this.updateOverlayMinHeight();
        });
      }

      init() {
        const isMobileViewport = window.innerWidth < this.mobileBreakpoint;
        if (isMobileViewport) {
          this.destroySlider();
        } else {
          this.initSlider();
        }
        this.updateOverlayMinHeight();
      }

      updateOverlayMinHeight() {
        const cards = this.querySelectorAll('.card-media--auto-height:not([class*=content-below])');
        let sharedMinHeight = 0;

        cards.forEach((card) => {
          const mediaWrapper = card.querySelector('.card-media__media-wrapper');
          const content = card.querySelector('.card-media__content');
          const contentWrapper = card.querySelector('.card-media__content-wrapper');
          if (!mediaWrapper || !content || !contentWrapper) return;

          card.style.removeProperty('--overlay-min-height');

          const mediaHeight = mediaWrapper.getBoundingClientRect().height;
          const contentStyles = window.getComputedStyle(content);
          const paddingTop = Number.parseFloat(contentStyles.paddingTop) || 0;
          const paddingBottom = Number.parseFloat(contentStyles.paddingBottom) || 0;
          const requiredHeight = contentWrapper.scrollHeight + paddingTop + paddingBottom;
          const minHeight = Math.ceil(Math.max(mediaHeight, requiredHeight));
          sharedMinHeight = Math.max(sharedMinHeight, minHeight);
        });

        cards.forEach((card) => {
          if (sharedMinHeight > 0) {
            card.style.setProperty('--overlay-min-height', `${sharedMinHeight}px`);
          }
        });
      }

      initSlider() {
        if (typeof this.sliderInstance === 'object') return;
        const columnGap = window.getComputedStyle(this.sliderWrapper).getPropertyValue('--f-column-gap');
        const spaceBetween = parseFloat(columnGap.replace('rem', '')) * 10;

        this.sliderOptions = {
          slidesPerView: 2,
          spaceBetween: spaceBetween,
          navigation: {
            nextEl: this.sectionEl.querySelector(this.selectors.nextEl),
            prevEl: this.sectionEl.querySelector(this.selectors.prevEl),
          },
          pagination: {
            el: this.sectionEl.querySelector(this.selectors.pagination),
            type: this.paginationType,
          },
          breakpoints: {
            768: {
              slidesPerView: this.tabletItems,
            },
            1024: {
              slidesPerView: this.laptopItems,
            },
            1280: {
              slidesPerView: this.items,
            },
          },
          loop: false,
          threshold: 2,
          watchSlidesProgress: true,
          mousewheel: {
            enabled: true,
            forceToAxis: true,
          },
        };

        this.classList.add(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.grid);
        this.sliderWrapper.classList.add(this.classes.swiperWrapper);

        this.sliderInstance = new window.FoxTheme.Carousel(this, this.sliderOptions, [FoxTheme.Swiper.Mousewheel]);
        this.sliderInstance.init();

        if (Shopify.designMode && typeof this.sliderInstance === 'object') {
          document.addEventListener('shopify:block:select', (e) => {
            if (e.detail.sectionId != this.sectionId) return;
            let { target } = e;
            const index = Number(target.dataset.index);

            this.sliderInstance.slider.slideTo(index);
          });
        }
      }

      destroySlider() {
        this.classList.remove(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.swiperWrapper);
        this.sliderWrapper.classList.add(this.classes.grid);
        if (typeof this.sliderInstance !== 'object') return;
        this.sliderInstance.slider.destroy();
        this.sliderInstance = false;
      }
    }
  );
}
